import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import { ICampaignStatistics } from "@/interfaces/campaign-statistics.interface";
import { StatisticsPageMessages } from "@/messages/campaigns/statistics/statistics-page.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { CampaignTableRow } from "./row";
import { CAMPAIGNS_TABLE_COLUMNS } from "../../constants";

interface Props {
  data: PaginatedResponse<ICampaignStatistics>;
  pagination: Pagination;
  messages: StatisticsPageMessages;
  campaignId: string;
}

export function CampaignTable({ data, pagination, messages, campaignId }: Props) {
  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {CAMPAIGNS_TABLE_COLUMNS(messages).map((label, index) => (
                <HeaderTableCell
                  align={index === 0 ? "left" : "center"}
                  key={`${index} - ${label}`}
                >
                  {label}
                </HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>

          <TableBody>
            {data.items.map((campaign, index) => (
              <CampaignTableRow
                key={`${index} - ${campaign.scheduleDate}`}
                campaign={campaign}
                index={index}
                messages={messages}
                campaignId={campaignId}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}
